import { isEmpty, isNumber } from 'lodash-es';

export const sanitizeString = (value: string | null | undefined): string | undefined => isEmpty(value) ? undefined : value as string;

export const sanitizeNumber = (value: number | null | undefined): number | undefined => {
  if (isNumber(value) && !isNaN(value)) {
    return value;
  }

  return undefined;
};
